import React from 'react';
import Layout from '../components/Layout';
import RegisterForm from '../components/RegisterCard';

function Register() {

  return (
    <Layout videoUrl="https://burakgundogan.net/videos/1093662-hd_1920_1080_30fps.mp4">
      <RegisterForm />
    </Layout>
  );
}

export default Register;